var chunkMapping = {
	"src_bootstrap_tsx": [
		34758
	],
	"src_App_tsx": [
		98061,
		81149,
		33098,
		62481,
		49145,
		13636,
		51449,
		79860,
		78222,
		14254
	]
};
var idToExternalAndNameMapping = {
	"13636": [
		"default",
		"./routing",
		66147
	],
	"14254": [
		"default",
		"./routing",
		82159
	],
	"33098": [
		"default",
		"./routing",
		41802
	],
	"34758": [
		"default",
		"./translations",
		7896
	],
	"49145": [
		"default",
		"./routing",
		90414
	],
	"51449": [
		"default",
		"./routing",
		8845
	],
	"62481": [
		"default",
		"./routing",
		7896
	],
	"78222": [
		"default",
		"./routing",
		56634
	],
	"79860": [
		"default",
		"./routing",
		5974
	],
	"81149": [
		"default",
		"./routing",
		17813
	],
	"98061": [
		"default",
		"./routes",
		45590
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}